import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { UserAccessMenuDto, UserAccessResponseDto } from '../../../models/system-settings/user-menu.model';

@Injectable({
  providedIn: 'root',
})
export class ApiSystemSettingsService {
  private baseUrl = environment.apiPrivateUrl;
  private cookieService = inject(CookieService);
  private apiMethodService = inject(ApiMethodService);

  // ================= Normal Functions =================

  constructor() { }

  // ================= API Functions =================

  /**
   * Fetches the user access menu from the backend API based on the user ID.
   * @param userId The ID of the user to load the menu structure for.
   */
  getUserAccessMenu(userId: number): Observable<UserAccessResponseDto> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<UserAccessResponseDto>(
      '/SystemSettings/getUserAccessMenu',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getUserAccessMenu',
        token: token,
        params: { userId: userId },
        headerOnly: false,
      }
    );
  }

  /**
   * Inserts a favorite menu.
   * @param payload The menu ID or required payload to insert.
   */
  insertFavoriteMenu(payload: any): Observable<any> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<any>(
      '/SystemSettings/insertFavoriteMenu',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'insertFavoriteMenu',
        token: token,
        body: payload,
        headerOnly: false,
      }
    );
  }

  /**
   * Deletes a favorite menu.
   * @param id The path ID.
   * @param userId The ID of the user.
   * @param menuId The ID of the menu.
   */
  deleteFavoriteMenu(id: number, userId: number, menuId: number): Observable<any> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<any>(
      `/SystemSettings/deleteFavoriteMenu/${id}`,
      'DELETE',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'deleteFavoriteMenu',
        token: token,
        params: { userId: userId, menuId: menuId },
        headerOnly: false,
      }
    );
  }
}
